import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_HOST;


export const getProductTypeBenifits = async (
  productId,
  page = 1,
  limit = 10
) => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    console.error("Access token missing");
    return;
  }

  const response = await axios.get(
    `${API_BASE_URL}/products/types/benefits/${productId}`,
    {
      params: { page, limit },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};



export const addGallery = async (formData) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/gallery/add`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};



export const getGalleryList = async (
  page = 1,
  limit = 10
) => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    console.error("Access token missing");
    return;
  }

  const response = await axios.get(
    `${API_BASE_URL}/gallery`,
    {
      params: {limit, page},
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const GalleryUpdate = async (payload) => {
  const token = localStorage.getItem("access_token");

  return axios.post(
    `${API_BASE_URL}/gallery/update`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};







export const getGalleryById = async (id) => {
  try {
    if (!id) {
      throw new Error("Product Type Benefit ID is required");
    }

    const token = localStorage.getItem("access_token");

    if (!token) {
      throw new Error("Access token not found");
    }

    const response = await axios.get(
      `${API_BASE_URL}/gallery/show/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching product type benefit:",
      error?.response?.data || error.message
    );
    throw error;
  }
};






export const deleteSpecificGallery = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/gallery/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

